// Catálogo padrão de serviços CPS (104 itens) com unidade pré-definida.
// Fonte: cps-servicos.html standalone (referência do cliente).
// Usuário pode digitar livremente também — este catálogo apenas sugere/preenche unidade.
export const CATALOGO_SERVICOS = [
  { descricao: "Catalogação", unidade: "verba" },
  { descricao: "Colocação (geral)", unidade: "verba" },
  { descricao: "Colocação — taxa mínima", unidade: "verba" },
  { descricao: "Colocação Borda de Piscina +0,40cm", unidade: "ml" },
  { descricao: "Colocação Borda de Piscina até 0,40cm", unidade: "ml" },
  { descricao: "Colocação de baguete", unidade: "ml" },
  { descricao: "Colocação de balcão", unidade: "un." },
  { descricao: "Colocação de bancada", unidade: "m²" },
  { descricao: "Colocação de bancada em dekton/lâmina", unidade: "m²" },
  { descricao: "Colocação de batente", unidade: "un." },
  { descricao: "Colocação de canjica", unidade: "m²" },
  { descricao: "Colocação de capa", unidade: "ml" },
  { descricao: "Colocação de cobertina", unidade: "ml" },
  { descricao: "Colocação de deck de madeira", unidade: "m²" },
  { descricao: "Colocação de divisórias", unidade: "m²" },
  { descricao: "Colocação de espelho", unidade: "un." },
  { descricao: "Colocação de filete", unidade: "ml" },
  { descricao: "Colocação de frontão", unidade: "ml" },
  { descricao: "Colocação de frontão acima de 14cm", unidade: "ml" },
  { descricao: "Colocação de grelha especial", unidade: "un." },
  { descricao: "Colocação de lareira", unidade: "un." },
  { descricao: "Colocação de lavatório", unidade: "un." },
  { descricao: "Colocação de lavatório com cuba de pedra", unidade: "un." },
  { descricao: "Colocação de lavatório em lâminas", unidade: "un." },
  { descricao: "Colocação de moldura", unidade: "ml" },
  { descricao: "Colocação de nicho", unidade: "un." },
  { descricao: "Colocação de nicho (metro linear)", unidade: "ml" },
  { descricao: "Colocação de nicho grande", unidade: "un." },
  { descricao: "Colocação de nicho médio", unidade: "un." },
  { descricao: "Colocação de nicho pequeno", unidade: "un." },
  { descricao: "Colocação de parede", unidade: "m²" },
  { descricao: "Colocação de parede — acima 1m de altura", unidade: "m²" },
  { descricao: "Colocação de parede diagonal", unidade: "m²" },
  { descricao: "Colocação de patamar", unidade: "un." },
  { descricao: "Colocação de peitoril", unidade: "ml" },
  { descricao: "Colocação de peitoril — uso de andaime", unidade: "ml" },
  { descricao: "Colocação de pia", unidade: "un." },
  { descricao: "Colocação de pia com cuba de pedra", unidade: "un." },
  { descricao: "Colocação de pia em lâminas", unidade: "un." },
  { descricao: "Colocação de pisada", unidade: "un." },
  { descricao: "Colocação de piso", unidade: "m²" },
  { descricao: "Colocação de piso até 10m²", unidade: "m²" },
  { descricao: "Colocação de piso decorado", unidade: "m²" },
  { descricao: "Colocação de piso diagonal", unidade: "m²" },
  { descricao: "Colocação de prateleira", unidade: "un." },
  { descricao: "Colocação de rodabase", unidade: "ml" },
  { descricao: "Colocação de rodameio", unidade: "ml" },
  { descricao: "Colocação de rodapé", unidade: "ml" },
  { descricao: "Colocação de rodateto", unidade: "ml" },
  { descricao: "Colocação de soleira", unidade: "ml" },
  { descricao: "Colocação de tabeira", unidade: "ml" },
  { descricao: "Colocação de tampo", unidade: "un." },
  { descricao: "Colocação de tampo em lâminas", unidade: "un." },
  { descricao: "Colocação de testeira", unidade: "ml" },
  { descricao: "Colocação diária", unidade: "diária" },
  { descricao: "Colocação dos itens acima", unidade: "verba" },
  { descricao: "Desmontagem de altar", unidade: "verba" },
  { descricao: "Escada", unidade: "verba" },
  { descricao: "Frete — fora da área urbana", unidade: "verba" },
  { descricao: "Frete — na região", unidade: "verba" },
  { descricao: "Frete e medição — área urbana", unidade: "verba" },
  { descricao: "Furação boca de cuba e colagem de cuba", unidade: "un." },
  { descricao: "Furação de cooktop no local", unidade: "un." },
  { descricao: "Furação de cuba de apoio", unidade: "un." },
  { descricao: "Furação de ralo", unidade: "un." },
  { descricao: "Furação de registro", unidade: "un." },
  { descricao: "Furação de tomada elétrica", unidade: "un." },
  { descricao: "Furação de torneira no local", unidade: "un." },
  { descricao: "Furação/colagem cuba de sobrepor grande", unidade: "un." },
  { descricao: "Furação/colagem cuba de sobrepor média", unidade: "un." },
  { descricao: "Furação/colagem cuba de sobrepor pequena", unidade: "un." },
  { descricao: "Furação/colagem cuba semiencaixe grande", unidade: "un." },
  { descricao: "Furação/colagem cuba semiencaixe média", unidade: "un." },
  { descricao: "Furação/colagem cuba semiencaixe pequena", unidade: "un." },
  { descricao: "Furos diversos no local", unidade: "un." },
  { descricao: "Impermeabilização pós obra", unidade: "m²" },
  { descricao: "Insumos restauração", unidade: "verba" },
  { descricao: "Levigação fosca em superfície de mármore", unidade: "m²" },
  { descricao: "Limpeza abrasiva", unidade: "m²" },
  { descricao: "Limpeza pós obra e impermeabilização", unidade: "m²" },
  { descricao: "Locação de equipamentos", unidade: "verba" },
  { descricao: "Mão de obra", unidade: "verba" },
  { descricao: "Medição e projeto", unidade: "verba" },
  { descricao: "MO e instalação da bancada e tampos", unidade: "verba" },
  { descricao: "Montagem de altar", unidade: "verba" },
  { descricao: "Polimento", unidade: "m²" },
  { descricao: "Polimento bancada de mármore", unidade: "m²" },
  { descricao: "Polimento bancadas", unidade: "verba" },
  { descricao: "Polimento em superfície de granito (P.S.G.)", unidade: "m²" },
  { descricao: "Polimento escada", unidade: "verba" },
  { descricao: "Prestação de serviço", unidade: "verba" },
  { descricao: "Projeto", unidade: "verba" },
  { descricao: "Regularização de contrapiso", unidade: "m²" },
  { descricao: "Rejunte e limpeza", unidade: "m²" },
  { descricao: "Restauração de mármores", unidade: "verba" },
  { descricao: "Retirada de bancada existente", unidade: "un." },
  { descricao: "Retirada de manta", unidade: "m²" },
  { descricao: "Retirada de piso existente", unidade: "m²" },
  { descricao: "Retirada e recolocação de cuba", unidade: "un." },
  { descricao: "Revisão de nichos", unidade: "verba" },
  { descricao: "Transporte especial", unidade: "verba" },
  { descricao: "Troca de cuba no local", unidade: "un." },
  { descricao: "Viagem", unidade: "verba" },
  { descricao: "Viagem, estadia e alimentação", unidade: "verba" },
];

// Índice descrição → unidade (para autofill quando usuário escolhe do catálogo)
export const UNIDADE_POR_DESCRICAO = CATALOGO_SERVICOS.reduce((acc, s) => {
  acc[s.descricao] = s.unidade;
  return acc;
}, {});
